import createFormModule from '../../utils/createFormModule'
import {
  SET_NAME,
  SET_WORKSPACE,
  SET_SIGNUP_ENABLED,
  SET_EMAIL_WHITELIST,
  SET_EMAIL_BLACKLIST,
  SET_THEME,
  SET_SVG_LOGO,
  SET_LOGO,
  SET_EMAIL_SIGNATURE,
  SET_TAGS
} from './types'

const formModule = createFormModule({ resourcePath: '/clients/:clientId', resourceName: 'client' })

export const state = {
  ...formModule.state,
  form: {
    name: '',
    workspace: '',
    signupEnabled: false,
    emailWhitelist: '',
    emailBlacklist: '',
    theme: '',
    svgLogo: '',
    logo: '',
    emailSignature: '',
    tags: []
  }
}

export const mutations = {
  ...formModule.mutations,
  [SET_NAME] (state, value) {
    state.form.name = value
  },
  [SET_WORKSPACE] (state, value) {
    state.form.workspace = value
  },
  [SET_SIGNUP_ENABLED] (state, value) {
    state.form.signupEnabled = value
  },
  [SET_EMAIL_WHITELIST] (state, value) {
    state.form.emailWhitelist = value
  },
  [SET_EMAIL_BLACKLIST] (state, value) {
    state.form.emailBlacklist = value
  },
  [SET_THEME] (state, value) {
    state.form.theme = value
  },
  [SET_SVG_LOGO] (state, value) {
    state.form.svgLogo = value
  },
  [SET_LOGO] (state, value) {
    state.form.logo = value
  },
  [SET_EMAIL_SIGNATURE] (state, value) {
    state.form.emailSignature = value
  },
  [SET_TAGS] (state, value) {
    state.form.tags = value
  }
}

export const actions = {
  ...formModule.actions,
  setName ({ commit }, value) {
    commit(SET_NAME, value)
  },
  setWorkspace ({ commit }, value) {
    commit(SET_WORKSPACE, value)
  },
  setSignupEnabled ({ commit }, value) {
    commit(SET_SIGNUP_ENABLED, value)
  },
  setEmailWhitelist ({ commit }, value) {
    commit(SET_EMAIL_WHITELIST, value)
  },
  setEmailBlacklist ({ commit }, value) {
    commit(SET_EMAIL_BLACKLIST, value)
  },
  setTheme ({ commit }, value) {
    commit(SET_THEME, value)
  },
  setSvgLogo ({ commit }, value) {
    commit(SET_SVG_LOGO, value)
  },
  setLogo ({ commit }, value) {
    commit(SET_LOGO, value)
  },
  setEmailSignature ({ commit }, value) {
    commit(SET_EMAIL_SIGNATURE, value)
  },
  setTags ({ commit }, value) {
    const tags = value.map(t => {
      return t.id
        ? { label: t.name, value: t.name }
        : { label: t.label, value: t.value }
    })
    commit(SET_TAGS, tags)
  }
}

export const getters = {
  ...formModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/clients/clientForm.js